<template>
  <div class="documentos-container">
    <CardIeaAppMain colorCard="transparent" title="" class="premium-wrapper">
      <v-col cols="12" class="pa-0">
        <!-- Hero Header -->
        <div class="hero-header glass-panel mb-4 py-3 px-6 mx-4 mt-4">
          <div class="d-flex align-center justify-space-between w-100 flex-wrap">
            <div class="d-flex align-center mb-2 mb-md-0">
              <v-btn icon dark color="primary" class="mr-4 glass-btn" @click="$router.go(-1)">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <div>
                <h1 class="text-h5 font-weight-bold primary-text mb-0">{{ title }}</h1>
                <p class="text-caption grey--text text--darken-1 mb-0">Revisa el estado de los documentos que has solicitado</p>
              </div>
            </div>
            <v-icon size="48" color="primary" class="opacity-30 d-none d-sm-block">mdi-file-document-multiple-outline</v-icon>
          </div>
        </div>

        <v-card class="glass-card rounded-xl overflow-hidden mx-4 mb-4" elevation="10">
          <div class="pa-6 bg-light min-h-400">
            <div class="d-flex align-center mb-6">
              <v-icon color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
              <h2 class="text-h6 font-weight-bold primary-text mb-0">Mis Trámites</h2>
            </div>
            
            <div v-if="tramitesUser.length === 0" class="d-flex flex-column align-center justify-center py-10">
               <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-file-hidden</v-icon>
               <h3 class="text-h6 grey--text text--darken-1 font-weight-medium text-center">No tienes trámites en curso</h3>
               <p class="grey--text text-center mt-2">Los documentos que solicites aparecerán aquí.</p>
            </div>

            <div class="d-flex flex-column gap-3" v-else>
              <v-card v-for="(tramiteUserData, tramitesUserKey) in tramitesUser" :key="tramitesUserKey" class="rounded-xl border-light bg-white hover-card overflow-hidden" elevation="0">
                <div class="pa-4 d-flex flex-column flex-sm-row justify-space-between align-sm-center gap-4">
                  
                  <div class="d-flex flex-grow-1 align-center">
                    <div class="icon-wrapper primary-light-bg mr-4 flex-shrink-0">
                      <v-icon color="primary">mdi-file-document-outline</v-icon>
                    </div>
                    <div>
                      <h3 class="text-subtitle-1 font-weight-bold primary-text mb-1">{{ tramiteUserData.documento_entregar.name }}</h3>
                      <div class="d-flex align-center text-caption grey--text text--darken-1" v-if="tramiteUserData.fecha_entregado">
                        <v-icon x-small color="grey" class="mr-1">mdi-calendar-check</v-icon> Entregado el: <span class="font-weight-medium ml-1">{{ tramiteUserData.fecha_entregado }}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div class="d-flex align-center min-w-max-content">
                    <v-chip class="font-weight-bold px-4" :color="tramiteUserData.status ? 'success' : 'warning'" :outlined="!tramiteUserData.status" :dark="!!tramiteUserData.status">
                      <v-icon small left v-if="tramiteUserData.status">mdi-check-circle</v-icon>
                      <v-icon small left v-else>mdi-clock-outline</v-icon>
                      {{ tramiteUserData.status ? 'Entregado' : 'Pendiente a Retirar' }}
                    </v-chip>
                  </div>
                  
                </div>
              </v-card>
            </div>
          </div>
        </v-card>
      </v-col>
    </CardIeaAppMain>
  </div>
</template>  
  <script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "DocumentosSolicitados",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title: "Documentos A Entregar",
    tramitesUser: [],
  }),

  methods: {
    async loadTramites() {
      let url = "documentos_entregar/alumno/" + this.$store.getters.user.IDStB;
      await this.$API
        .get({
          url: url,
        })
        .then((res) => {
          this.tramitesUser = res;
        });
    },
  },

  mounted() {
    if (
      this.$store.getters.user.borrado == 1 ||
      this.$store.getters.user.alumno_mora == true ||
      this.$store.getters.user.excedente
    ) {
      this.$router.push({
        name: "Home",
      });
    }

    this.loadTramites();
  },
};
</script>

<style scoped>
/* Glassmorphism Classes (Premium UI) */
.documentos-container { background: transparent !important; min-height: calc(100vh - 120px); }
.glass-panel { background: rgba(255, 255, 255, 0.7) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.5) !important; box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.05) !important; border-radius: 20px; padding: 24px; }
.glass-card { background: rgba(255, 255, 255, 0.85) !important; backdrop-filter: blur(16px) !important; border: 1px solid rgba(255, 255, 255, 0.4) !important; }
.glass-btn { background: rgba(25, 118, 210, 0.1) !important; backdrop-filter: blur(4px) !important; box-shadow: none !important; transition: all 0.3s ease; }
.glass-btn:hover { background: rgba(25, 118, 210, 0.2) !important; transform: translateY(-2px); }
.bg-light { background-color: #f8fafc !important; }
.border-light { border: 1px solid rgba(0, 0, 0, 0.05) !important; }
.hover-card { transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1); border-left: 4px solid transparent; }
.hover-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px -8px rgba(0, 0, 0, 0.12) !important; border-left-color: var(--v-primary-base, #1976d2); }
.primary-text { color: #1e293b; }
.opacity-30 { opacity: 0.3; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 16px; }
.min-w-max-content { min-width: max-content; }
.min-h-400 { min-height: 400px; }
.icon-wrapper { width: 48px; height: 48px; border-radius: 12px; display: flex; align-items: center; justify-content: center; }
.primary-light-bg { background-color: rgba(25, 118, 210, 0.08); }
</style>